import { defineComponent as t, openBlock as n, createBlock as a, unref as l, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconSearch",
  __name: "IconSearch",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (d, e) => (n(), a(l(m), p(r, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M10 2.25a7.75 7.75 0 1 0 4.924 13.735l5.546 5.545a.75.75 0 1 0 1.06-1.06l-5.545-5.546A7.75 7.75 0 0 0 10 2.25M3.75 10a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
